import { useState } from 'react';
import { firebaseDB } from '../../../firebase-config';
import { updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { ListItem, ListItemText, IconButton } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../../contexts';
import { ChangeChild } from './change-child';


export const ListChild = ({ child, getUserChildren }) => {
    const { id, name, age } = child;
    const { user } = useAuth();
    const [showInputChange, setShowInputChange] = useState(false);
    const [nameStart, setNameStart] = useState(name);
    const [ageStart, setAgeStart] = useState(age);
    const [error, setError] = useState(false);

    const handleShowInputChange = () => {
        setShowInputChange(!showInputChange);
    };
    const handleDelete = async (id) => {
        await deleteDoc(doc(firebaseDB, `usersChildren/${user.uid}/children`, id))
        getUserChildren();
    };
    const handlerName = (value) => setNameStart(value);
    const handlerAge = (value) => setAgeStart(value);
    const handleChange = async (id, element) => {
        element.preventDefault();
        setError(false);
        if (!nameStart.trim() || !ageStart) {
            setError(true);
            return;
        }
        const child = doc(firebaseDB, `usersChildren/${user.uid}/children`, id);
        await updateDoc(child, { name: nameStart, age: ageStart });
        getUserChildren();
        setShowInputChange(!showInputChange);
    };

    return (
        <ListItem
            sx={{ marginBottom: '6px', justifyContent: 'space-between' }}
            key={id}>
            {showInputChange ?
                <ChangeChild nameStart={nameStart}
                    ageStart={ageStart}
                    handlerName={handlerName}
                    handlerAge={handlerAge}
                    idChild={id}
                    handleChange={handleChange}
                    error={error} /> :
                <div className='user-list_item'>
                    <ListItemText primary={name} />
                    <ListItemText primary={age} />
                </div>}
            <div>
                <IconButton onClick={() => handleShowInputChange(id)}>
                    <CreateIcon />
                </IconButton>
                <IconButton onClick={() => handleDelete(id)}>
                    <DeleteIcon />
                </IconButton>
            </div>
        </ListItem>
    )
}